import { Component } from '@angular/core';

@Component({
  selector: 'app-home-visual',
  templateUrl: './home-visual.html',
  styleUrl: './home-visual.scss',
  host: { 'aria-hidden': 'true' },
})
export class HomeVisual {}
